import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1314ce63"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12 d-flex" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  ref: "form",
  class: "tps-form"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "Client info", -1))
const _hoisted_8 = { class: "row" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 text-end fw-bold" }, "Type:", -1))
const _hoisted_10 = { class: "col-9 text-start" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["value"]
const _hoisted_13 = ["value"]
const _hoisted_14 = ["value"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "Sales rep info", -1))
const _hoisted_16 = { class: "row" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 text-end fw-bold" }, "Sales rep:", -1))
const _hoisted_18 = { class: "col-9 text-start" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  key: null,
  value: null
}
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "row" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 text-end fw-bold" }, "Transferred:", -1))
const _hoisted_24 = { class: "col-9 text-start" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "Account handler info", -1))
const _hoisted_26 = { class: "row" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 text-end fw-bold" }, "Account handler:", -1))
const _hoisted_28 = { class: "col-9 text-start" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = {
  key: null,
  value: null
}
const _hoisted_31 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_k_notification = _resolveComponent("k-notification")!
  const _component_k_switch = _resolveComponent("k-switch")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_k_notification, { ref: "popupNotification" }, null, 512),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              class: "btn btn-warning",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.save())),
              disabled: !_ctx.isValidForm || _ctx.isLoading || _ctx.isDisabled
            }, " Save ", 8, _hoisted_5)
          ])
        ]),
        _createElementVNode("form", _hoisted_6, [
          _createElementVNode("fieldset", null, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.salesConfiguration.type) = $event)),
                  disabled: _ctx.isLoading || _ctx.isDisabled,
                  class: "form-control"
                }, [
                  (_openBlock(), _createElementBlock("option", {
                    key: _ctx.ClientType.InHouse,
                    value: _ctx.ClientType.InHouse
                  }, " House ", 8, _hoisted_12)),
                  (_openBlock(), _createElementBlock("option", {
                    key: _ctx.ClientType.FrenzyClient,
                    value: _ctx.ClientType.FrenzyClient
                  }, " Frenzy Client ", 8, _hoisted_13)),
                  (_openBlock(), _createElementBlock("option", {
                    key: _ctx.ClientType.NonFrenzyClient,
                    value: _ctx.ClientType.NonFrenzyClient
                  }, " Non-Frenzy Client ", 8, _hoisted_14))
                ], 8, _hoisted_11), [
                  [_vModelSelect, _ctx.salesConfiguration.type]
                ])
              ])
            ])
          ]),
          _createElementVNode("fieldset", null, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.salesConfiguration.salesRepId) = $event)),
                  disabled: _ctx.isLoading || _ctx.isDisabled,
                  class: "form-control"
                }, [
                  (_openBlock(), _createElementBlock("option", _hoisted_20, "Choose the user...")),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.salesRepUsers, (salesRepUser) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: salesRepUser.Id,
                      value: salesRepUser.Id
                    }, _toDisplayString(salesRepUser.Name), 9, _hoisted_21))
                  }), 128))
                ], 8, _hoisted_19), [
                  [_vModelSelect, _ctx.salesConfiguration.salesRepId]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_k_switch, {
                  disabled: true,
                  checked: _ctx.transferred
                }, null, 8, ["checked"])
              ])
            ])
          ]),
          _createElementVNode("fieldset", null, [
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("div", _hoisted_28, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.salesConfiguration.accountHandlerId) = $event)),
                  disabled: _ctx.isLoading || _ctx.isDisabled,
                  class: "form-control"
                }, [
                  (_openBlock(), _createElementBlock("option", _hoisted_30, " Choose the user... ")),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accountHandlerUsers, (accountHandlerUser) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: accountHandlerUser.Id,
                      value: accountHandlerUser.Id
                    }, _toDisplayString(accountHandlerUser.Name), 9, _hoisted_31))
                  }), 128))
                ], 8, _hoisted_29), [
                  [_vModelSelect, _ctx.salesConfiguration.accountHandlerId]
                ])
              ])
            ])
          ])
        ], 512)
      ])
    ])
  ], 64))
}